import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Add Bank account")
const _hoisted_2 = { class: "flex-1" }
const _hoisted_3 = { class: "c-title f-md mt-32" }
const _hoisted_4 = { class: "mt-8 mb-24" }
const _hoisted_5 = { class: "form-item block" }
const _hoisted_6 = { class: "form-item block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_t = _resolveComponent("t")
  const _component_Button = _resolveComponent("Button")
  const _component_DialogTemplate = _resolveComponent("DialogTemplate")

  return (_openBlock(), _createBlock(_component_DialogTemplate, null, {
    title: _withCtx(() => [
      _createVNode(_component_t, { path: "withdrawal_9" }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      })
    ]),
    confirm: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "f-bold f-lg primary flex-1",
        onClick: _ctx.submit,
        progress: _ctx.progress
      }, {
        default: _withCtx(() => [
          _createVNode(_component_t, {
            path: "withdrawal_14",
            custom: ""
          }, {
            default: _withCtx(({td}) => [
              _createTextVNode(_toDisplayString(td || 'Submit'), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onClick", "progress"])
    ]),
    default: _withCtx(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode("p", _hoisted_3, [
          _createVNode(_component_t, {
            path: "withdrawal_10",
            args: {name: _ctx.name}
          }, {
            default: _withCtx(() => [
              _createTextVNode("Payee's name: " + _toDisplayString(_ctx.name), 1)
            ]),
            _: 1
          }, 8, ["args"])
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_t, {
              path: "withdrawal_11",
              custom: ""
            }, {
              default: _withCtx(({td}) => [
                _withDirectives(_createVNode("input", {
                  class: "input",
                  type: "text",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.account = $event)),
                  placeholder:  td || 'Bank Account Number'
                }, null, 8, ["placeholder"]), [
                  [_vModelText, _ctx.account]
                ])
              ]),
              _: 1
            })
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode(_component_t, {
              path: "withdrawal_12",
              custom: ""
            }, {
              default: _withCtx(({td}) => [
                _withDirectives(_createVNode("input", {
                  class: "input",
                  type: "text",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.ifsc = $event)),
                  placeholder:  td || 'IFSC Code'
                }, null, 8, ["placeholder"]), [
                  [_vModelText, _ctx.ifsc]
                ])
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _: 1
  }))
}